import { Component, Input } from '@angular/core'

@Component({
  selector: 'vmf-fund-options',
  templateUrl: './fund-options.component.html',
  styleUrls: ['./fund-options.component.scss'],
})
export class FundOptionsComponent {
  @Input() performanceModel: any
}
